import { render } from "./SidebarToggler.vue?vue&type=template&id=415826b4&scoped=true"
import script from "./SidebarToggler.vue?vue&type=script&lang=js"
export * from "./SidebarToggler.vue?vue&type=script&lang=js"

import "./SidebarToggler.vue?vue&type=style&index=0&id=415826b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-415826b4"],['__file',"src/layouts/sidebar/SidebarToggler.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "415826b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('415826b4', __exports__)) {
    api.reload('415826b4', __exports__)
  }
  
  module.hot.accept("./SidebarToggler.vue?vue&type=template&id=415826b4&scoped=true", () => {
    api.rerender('415826b4', render)
  })

}


export default __exports__